module.exports = __webpack_public_path__ + "img/7.c5c79616.jpg";